import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/FmsTypes";
import { UserTypeEnum } from "@/types/FmsEnums";
import { useGlobalModel } from "@/model/globalModel";
import { transPgToPagination } from "@/views/base/app/appModel";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { contractManageService } from "@/views/contract/manage/ContractManageService";
import { ContractDetailSearch, AccountOpenResult } from "@/views/contract/manage/ContractManageTypes";
import { summaryModel } from "../../customer/summaryModel";

export const openDataModel = createModel(function () {
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    const { user: { shopCode }, beDs, setLoadingInfo } = useGlobalModel();
    const { detailPartner } = summaryModel();

    const [loading, setLoading] = useState(false)
    //查询条件
    const [searchParam, setSearchParam] = useState<ContractDetailSearch>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<AccountOpenResult[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedData, setSelectedData] = useState<AccountOpenResult[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //审核弹窗
    const [openDrawerVisible, setOpenDrawerVisible] = useState(false);


    const onSearch = () => {
        loadData({ pageNum: 1 }, { ...searchParam })
    }

    const onReset = () => {
        setSearchParam({});
        loadData(initPgCfg, {});
        setSelectedRowKeys([]);
        setSelectedData([]);
    }

    const updateSearchParam = (updateParam: ContractDetailSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: ContractDetailSearch = searchParam) => {
        setLoading(true);
        setDataSource([]);
        const searchParams = {
            ...defaultMdCmParam,
            ...searchValue,
            shopCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER,
            partnerCode: detailPartner,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await contractManageService.monthAccountOpenPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);

        setLoading(false);
    }

    return {
        /***field***/
        loading,
        initPgCfg,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        beDs,
        openDrawerVisible,
        /***method***/
        setSelectedData,
        setDataSource,
        setSelectedRowKeys,
        updateSearchParam,
        loadData,
        onSearch,
        onReset,
        setOpenDrawerVisible,
    }
});